/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description constant for app
 */

import _ from 'lodash';
import moment from 'moment';
import { ThemeConfig } from 'antd';

import { LokiLogInfo } from 'client/api';

export const MESSAGE_DISPLAY_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const CONNECTOR_DIRECTORY_INITIAL_PATH = '/';

export const ZSEGMENT_ENGINE = 'zsegment-engine';

export const ZSEGMENT_API = 'zsegment-api';

export const keycloakRoles = {
	ADMIN: '_admin',
	DEFAULT_USER: 'manage-default-users',
	MANAGE_CONNECTOR: 'manage-connector',
	MANAGE_CREDENTIALS: 'manage-credentials',
	MANAGE_INTERFACE_MIGRATION: 'manage-interface-migrations',
	MANAGE_LIBRARIES: 'manage-libraries',
	MANAGE_MESSAGES: 'manage-messages',
	MANAGE_TASKS: 'manage-tasks',
	MANAGE_METRIC_DASHBOARD: 'manage-metric-dashboard',
};

export const disabledRouteComponent = [
	'zookeeper',
	'zendesk',
	'zeebe',
	'xmpp',
	'whatsapp',
	'workday',
	'xchange',
	'weather',
	'twitter-search',
	'undertow',
	'twitter-timeline',
	'twitter-directmessage',
	'twilio',
	'telegram',
	'stub',
	'spring-batch',
	'spring-event',
	'spring-jdbc',
	'spring-ldap',
	'spring-rabbitmq',
	'spring-redis',
	'spring-ws',
	'slack',
	'salesforce',
	'sap-netweaver',
	'robotframework',
	'quickfix',
	'pulsar',
	'pubnub',
	'lpr',
	'plc4x',
	'paho-mqtt5',
	'paho',
	'optaplanner',
	'openstack-swift',
	'openstack-nova',
	'openstack-keystone',
	'openstack-neutron',
	'olingo4',
	'olingo2',
	'netty-http',
	'netty',
	'jira',
	'dropbox',
	'digitalocean',
	'dhis2',
	'box',
	'chatscript',
	'openshift',
	'openstack',
	'kubernetes',
	'ignite',
	'hwcloud',
];

export const roleOptions = [
	{ label: 'Admin', value: keycloakRoles.ADMIN },

	{
		label: 'Default User',
		value: keycloakRoles.DEFAULT_USER,
	},
	{
		label: 'Can Manage Connector',
		value: keycloakRoles.MANAGE_CONNECTOR,
	},
	{
		label: 'Can Manage Credentials',
		value: keycloakRoles.MANAGE_CREDENTIALS,
	},
	{
		label: 'Can Manage Interface Migration',
		value: keycloakRoles.MANAGE_INTERFACE_MIGRATION,
	},
	{
		label: 'Can Manage Libraries',
		value: keycloakRoles.MANAGE_LIBRARIES,
	},
	{
		label: 'Can Manage Messages',
		value: keycloakRoles.MANAGE_MESSAGES,
	},

	{
		label: 'Can Manage Tasks',
		value: keycloakRoles.MANAGE_TASKS,
	},
	{
		label: 'Can Manage Metric Dashboard',
		value: keycloakRoles.MANAGE_METRIC_DASHBOARD,
	},
];
export const keyedRoles = _.keyBy(roleOptions, 'value');

export const APPLOGS_DATEFORMAT = 'YYYY-MM-DD HH:mm:ss';

export const antdTheme: ThemeConfig = {
	token: {
		colorPrimary: '#044FB3',
		colorLink: '#044FB3',
		colorLinkHover: '#5B47B6',
		colorBgContainerDisabled: '#FFF',
		fontWeightStrong: 500,
	},
	components: {
		Table: {
			borderColor: '#f0f0f0',
			headerBg: '#f9f9fb',
			padding: 16,
			paddingContentVerticalLG: 12,
			rowHoverBg: '#fdf4e6 !important',
			bodySortBg: 'transparent',
			rowSelectedBg: '#fff',
		},
		Typography: {
			titleMarginBottom: 0,
			titleMarginTop: 0,
		},
		Divider: {
			colorSplit: '#E2E8F0',
		},
	},
};

export const GROOVY_EXECUTION_CLASS = 'com.e314.zsegment.api.scheduler.job.GroovyScriptExecutingJob';
export const TASK_DIRECTORY = 'tasks';

export const DATE_FORMAT_FRACTIONAL_SECONDS = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

export const DEFAULT_TIME_ZONE = 'Asia/Kolkata';

export const TASK_TYPES = {
	predefined: 'Predefined',
	custom: 'Custom',
};

export const GROOVY_TASK = 'GroovyScriptExecutingJob';

export const RECORD_DATA_TYPES = ['STRING', 'INTEGER', 'DOUBLE', 'DATE_TIME'];

export const kindToLanguageMapping = {
	mappings: 'yaml',
	schema: 'xml',
	routes: 'yaml',
	script: 'java',
};
export const DATE_FORMAT = 'YYYY--MM-DD';

export const excludedFolderList = ['common', 'functions', 'tasks'];

export const INTERFACE_MIGRATION_FILES_TO_IGNORE = {
	SCHEMA_FILE: 'schemas.json',
	CUSTOM_JAR_FILE: 'customJars.json',
	INTERFACE_PROTOCOL_CONNECTOR_FILE: 'interface_protocols.json',
	GITIGNORE_PATTERN: '/.gitignore',
	JAR_PATTERN: 'jar/',
	COMMON_JAR_PATTERN: '/jar/',
	SCHEMA_CUSTOM_PATTERN: 'schema/custom/',
	SCHEMA_PREDEFINED_PATTERN: 'schema/predefined/',
	DATABASE_FILE: 'database.json',
	MANIFEST_FILE: 'manifest.json',
};

export const cronPattern =
	// eslint-disable-next-line no-useless-escape, max-len
	/^\s*($|#|\w+\s*=|(\?|\*|(?:[0-5]?\d)(?:(?:-|\/|\,)(?:[0-5]?\d))?(?:,(?:[0-5]?\d)(?:(?:-|\/|\,)(?:[0-5]?\d))?)*)\s+(\?|\*|(?:[0-5]?\d)(?:(?:-|\/|\,)(?:[0-5]?\d))?(?:,(?:[0-5]?\d)(?:(?:-|\/|\,)(?:[0-5]?\d))?)*)\s+(\?|\*|(?:[01]?\d|2[0-3])(?:(?:-|\/|\,)(?:[01]?\d|2[0-3]))?(?:,(?:[01]?\d|2[0-3])(?:(?:-|\/|\,)(?:[01]?\d|2[0-3]))?)*)\s+(\?|\*|(?:0?[1-9]|[12]\d|3[01])(?:(?:-|\/|\,)(?:0?[1-9]|[12]\d|3[01]))?(?:,(?:0?[1-9]|[12]\d|3[01])(?:(?:-|\/|\,)(?:0?[1-9]|[12]\d|3[01]))?)*)\s+(\?|\*|(?:[1-9]|1[012])(?:(?:-|\/|\,)(?:[1-9]|1[012]))?(?:L|W)?(?:,(?:[1-9]|1[012])(?:(?:-|\/|\,)(?:[1-9]|1[012]))?(?:L|W)?)*|\?|\*|(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(?:(?:-)(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?(?:,(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(?:(?:-)(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?)*)\s+(\?|\*|(?:[0-6])(?:(?:-|\/|\,|#)(?:[0-6]))?(?:L)?(?:,(?:[0-6])(?:(?:-|\/|\,|#)(?:[0-6]))?(?:L)?)*|\?|\*|(?:MON|TUE|WED|THU|FRI|SAT|SUN)(?:(?:-)(?:MON|TUE|WED|THU|FRI|SAT|SUN))?(?:,(?:MON|TUE|WED|THU|FRI|SAT|SUN)(?:(?:-)(?:MON|TUE|WED|THU|FRI|SAT|SUN))?)*)(|\s)+(\?|\*|(?:|\d{4})(?:(?:-|\/|\,)(?:|\d{4}))?(?:,(?:|\d{4})(?:(?:-|\/|\,)(?:|\d{4}))?)*))$/;

export const messageEncodingOptions = [
	{
		value: 'UTF-8',
		label: 'UTF-8',
	},
];

export const customFieldActionTemplate = `package custom_field_actions;
import java.io.Serializable;
import io.atlasmap.v2.*
import io.atlasmap.spi.AtlasFieldAction;
import io.atlasmap.spi.AtlasActionProcessor;

public class ClassName implements AtlasFieldAction {

    public static class ActionName extends Action implements Serializable {
        @AtlasActionProperty(title = "Action title", type = FieldType.STRING)
        public String exampleProperty = "-temp-";

    }

    @AtlasActionProcessor
    public static String actionName(ActionName action, String userInput) {
        return "example-" + action.exampleProperty + userInput;
    }

}
`;

export const HL7_FILETYPE = 'hl7';
export const X12_FILETYPE = 'x12';

export const formatAppLogs = (log: LokiLogInfo): string =>
	`${moment.utc(log.log_timestamp).local().format(APPLOGS_DATEFORMAT)} | ${log.log_line}`;

export const appOptions = [
	{ label: 'API', value: 'API' },
	{ label: 'ENGINE', value: 'ENGINE' },
	{ label: 'GROOVY ENGINE', value: 'GROOVY_ENGINE' },
	{ label: 'JOB HISTORY', value: 'JOB_HISTORY' },
];

export const logLevelOptions = [
	{ label: 'INFO', value: 'INFO' },
	{ label: 'WARN', value: 'WARN' },
	{ label: 'ERROR', value: 'ERROR' },
	{ label: 'DEBUG', value: 'DEBUG' },
];

const extended_composite_id_number_and_name_for_persons = 'Extended Composite Id Number And Name For Persons';
const coded_with_exceptions = 'Coded With Exceptions';
const time_stamp = 'Time Stamp';
const coded_element = 'Coded Element';
const string_data = 'String Data';
const coded_values_for_hl7_tables = 'Coded values for HL7 tables';
const extended_address = 'Extended Address';
const sequence_id = 'Sequence ID';

export const hl7Segments = {
	ABS: [
		{
			id: 'ABS.1',
			type: 'Field',
			position: 'ABS.1',
			length: 0,
			dataType: 'XCN',
			dataTypeName: { extended_composite_id_number_and_name_for_persons },
			usage: 'O',
			rpt: '1',
			tableId: '0010',
			tableName: 'Physician ID',
			name: 'Discharge Care Provider',
			description: null,
		},
		{
			id: 'ABS.2',
			type: 'Field',
			position: 'ABS.2',
			length: 0,
			dataType: 'CWE',
			dataTypeName: { coded_with_exceptions },
			usage: 'O',
			rpt: '1',
			tableId: '0069',
			tableName: 'Hospital Service',
			name: 'Transfer Medical Service Code',
			description: null,
		},
		{
			id: 'ABS.3',
			type: 'Field',
			position: 'ABS.3',
			length: 0,
			dataType: 'CWE',
			dataTypeName: { coded_with_exceptions },
			usage: 'O',
			rpt: '1',
			tableId: '0421',
			tableName: 'Severity of Illness Code',
			name: 'Severity Of Illness Code',
			description: null,
		},
		{
			id: 'ABS.4',
			type: 'Field',
			position: 'ABS.4',
			length: 0,
			dataType: 'DTM',
			dataTypeName: 'Date/time',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Date/Time Of Attestation',
			description: null,
		},
		{
			id: 'ABS.5',
			type: 'Field',
			position: 'ABS.5',
			length: 0,
			dataType: 'XCN',
			dataTypeName: { extended_composite_id_number_and_name_for_persons },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Attested By',
			description: null,
		},
		{
			id: 'ABS.6',
			type: 'Field',
			position: 'ABS.6',
			length: 0,
			dataType: 'CWE',
			dataTypeName: { coded_with_exceptions },
			usage: 'O',
			rpt: '1',
			tableId: '0422',
			tableName: 'Triage Code',
			name: 'Triage Code',
			description: null,
		},
		{
			id: 'ABS.7',
			type: 'Field',
			position: 'ABS.7',
			length: 0,
			dataType: 'DTM',
			dataTypeName: 'Date/time',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Abstract Completion Date/Time',
			description: null,
		},
		{
			id: 'ABS.8',
			type: 'Field',
			position: 'ABS.8',
			length: 0,
			dataType: 'XCN',
			dataTypeName: { extended_composite_id_number_and_name_for_persons },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Abstracted By',
			description: null,
		},
		{
			id: 'ABS.9',
			type: 'Field',
			position: 'ABS.9',
			length: 0,
			dataType: 'CWE',
			dataTypeName: { coded_with_exceptions },
			usage: 'O',
			rpt: '1',
			tableId: '0423',
			tableName: 'Case Category Code',
			name: 'Case Category Code',
			description: null,
		},
		{
			id: 'ABS.10',
			type: 'Field',
			position: 'ABS.10',
			length: 1,
			dataType: 'ID',
			dataTypeName: 'Coded Value For Hl7 Defined Tables',
			usage: 'O',
			rpt: '1',
			tableId: '0136',
			tableName: 'Yes/no Indicator',
			name: 'Caesarian Section Indicator',
			description: null,
		},
		{
			id: 'ABS.11',
			type: 'Field',
			position: 'ABS.11',
			length: 0,
			dataType: 'CWE',
			dataTypeName: { coded_with_exceptions },
			usage: 'O',
			rpt: '1',
			tableId: '0424',
			tableName: 'Gestation Category Code',
			name: 'Gestation Category Code',
			description: null,
		},
		{
			id: 'ABS.12',
			type: 'Field',
			position: 'ABS.12',
			length: 0,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Gestation Period - Weeks',
			description: null,
		},
		{
			id: 'ABS.13',
			type: 'Field',
			position: 'ABS.13',
			length: 0,
			dataType: 'CWE',
			dataTypeName: { coded_with_exceptions },
			usage: 'O',
			rpt: '1',
			tableId: '0425',
			tableName: 'Newborn Code',
			name: 'Newborn Code',
			description: null,
		},
		{
			id: 'ABS.14',
			type: 'Field',
			position: 'ABS.14',
			length: 1,
			dataType: 'ID',
			dataTypeName: 'Coded Value For Hl7 Defined Tables',
			usage: 'O',
			rpt: '1',
			tableId: '0136',
			tableName: 'Yes/no Indicator',
			name: 'Stillborn Indicator',
			description: null,
		},
	],
	ACC: [
		{
			id: 'ACC.1',
			type: 'Field',
			position: 'ACC.1',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Accident Date/Time',
			description: null,
		},
		{
			id: 'ACC.2',
			type: 'Field',
			position: 'ACC.2',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: '0050',
			tableName: 'Accident Code',
			name: 'Accident Code',
			description: null,
		},
		{
			id: 'ACC.3',
			type: 'Field',
			position: 'ACC.3',
			length: 25,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Accident Location',
			description: null,
		},
		{
			id: 'ACC.4',
			type: 'Field',
			position: 'ACC.4',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'B',
			rpt: '1',
			tableId: '0347',
			tableName: 'State/province',
			name: 'Auto Accident State',
			description: null,
		},
		{
			id: 'ACC.5',
			type: 'Field',
			position: 'ACC.5',
			length: 1,
			dataType: 'ID',
			dataTypeName: { coded_values_for_hl7_tables },
			usage: 'O',
			rpt: '1',
			tableId: '0136',
			tableName: 'Yes/no indicator',
			name: 'Accident Job Related Indicator',
			description: null,
		},
		{
			id: 'ACC.6',
			type: 'Field',
			position: 'ACC.6',
			length: 12,
			dataType: 'ID',
			dataTypeName: { coded_values_for_hl7_tables },
			usage: 'O',
			rpt: '1',
			tableId: '0136',
			tableName: 'Yes/no indicator',
			name: 'Accident Death Indicator',
			description: null,
		},
		{
			id: 'ACC.7',
			type: 'Field',
			position: 'ACC.7',
			length: 250,
			dataType: 'XCN',
			dataTypeName: { extended_composite_id_number_and_name_for_persons },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Entered By',
			description: null,
		},
		{
			id: 'ACC.8',
			type: 'Field',
			position: 'ACC.8',
			length: 25,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Accident Description',
			description: null,
		},
		{
			id: 'ACC.9',
			type: 'Field',
			position: 'ACC.9',
			length: 80,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Brought In By',
			description: null,
		},
		{
			id: 'ACC.10',
			type: 'Field',
			position: 'ACC.10',
			length: 1,
			dataType: 'ID',
			dataTypeName: { coded_values_for_hl7_tables },
			usage: 'O',
			rpt: '1',
			tableId: '0136',
			tableName: 'Yes/no indicator',
			name: 'Police Notified Indicator',
			description: null,
		},
		{
			id: 'ACC.11',
			type: 'Field',
			position: 'ACC.11',
			length: 250,
			dataType: 'XAD',
			dataTypeName: { extended_address },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Accident Address',
			description: null,
		},
	],
	ADD: [
		{
			id: 'ADD.1',
			type: 'Field',
			position: 'ADD.1',
			length: 65536,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Addendum Continuation Pointer',
			description: null,
		},
	],
	AFF: [
		{
			id: 'AFF.1',
			type: 'Field',
			position: 'AFF.1',
			length: 60,
			dataType: 'SI',
			dataTypeName: { sequence_id },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Set ID - AFF',
			description: null,
		},
		{
			id: 'AFF.2',
			type: 'Field',
			position: 'AFF.2',
			length: 250,
			dataType: 'XON',
			dataTypeName: 'Extended Composite Name and Identification Number for Organizations',
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Professional Organization',
			description: null,
		},
		{
			id: 'AFF.3',
			type: 'Field',
			position: 'AFF.3',
			length: 250,
			dataType: 'XAD',
			dataTypeName: { extended_address },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Professional Organization Address',
			description: null,
		},
		{
			id: 'AFF.4',
			type: 'Field',
			position: 'AFF.4',
			length: 52,
			dataType: 'DR',
			dataTypeName: 'Date/Time Range',
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Professional Organization Affiliation Date Range',
			description: null,
		},
		{
			id: 'AFF.5',
			type: 'Field',
			position: 'AFF.5',
			length: 60,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Professional Affiliation Additional Information',
			description: null,
		},
	],
	AIG: [
		{
			id: 'AIG.1',
			type: 'Field',
			position: 'AIG.1',
			length: 4,
			dataType: 'SI',
			dataTypeName: { sequence_id },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Set ID - AIG',
			description: null,
		},
		{
			id: 'AIG.2',
			type: 'Field',
			position: 'AIG.2',
			length: 3,
			dataType: 'ID',
			dataTypeName: { coded_values_for_hl7_tables },
			usage: 'C',
			rpt: '1',
			tableId: '0206',
			tableName: 'Segment action code',
			name: 'Segment Action Code',
			description: null,
		},
		{
			id: 'AIG.3',
			type: 'Field',
			position: 'AIG.3',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Resource ID',
			description: null,
		},
		{
			id: 'AIG.4',
			type: 'Field',
			position: 'AIG.4',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Resource Type',
			description: null,
		},
		{
			id: 'AIG.5',
			type: 'Field',
			position: 'AIG.5',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Resource Group',
			description: null,
		},
		{
			id: 'AIG.6',
			type: 'Field',
			position: 'AIG.6',
			length: 5,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Resource Quantity',
			description: null,
		},
		{
			id: 'AIG.7',
			type: 'Field',
			position: 'AIG.7',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Resource Quantity Units',
			description: null,
		},
		{
			id: 'AIG.8',
			type: 'Field',
			position: 'AIG.8',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time',
			description: null,
		},
		{
			id: 'AIG.9',
			type: 'Field',
			position: 'AIG.9',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset',
			description: null,
		},
		{
			id: 'AIG.10',
			type: 'Field',
			position: 'AIG.10',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset Units',
			description: null,
		},
		{
			id: 'AIG.11',
			type: 'Field',
			position: 'AIG.11',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration',
			description: null,
		},
		{
			id: 'AIG.12',
			type: 'Field',
			position: 'AIG.12',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration Units',
			description: null,
		},
		{
			id: 'AIG.13',
			type: 'Field',
			position: 'AIG.13',
			length: 10,
			dataType: 'IS',
			dataTypeName: 'Coded value for user-defined tables',
			usage: 'C',
			rpt: '1',
			tableId: '0279',
			tableName: 'Allow Substitution Codes',
			name: 'Allow Substitution Code',
			description: null,
		},
		{
			id: 'AIG.14',
			type: 'Field',
			position: 'AIG.14',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: '0278',
			tableName: 'Filler status codes',
			name: 'Filler Status Code',
			description: null,
		},
	],
	AIL: [
		{
			id: 'AIL.1',
			type: 'Field',
			position: 'AIL.1',
			length: 4,
			dataType: 'SI',
			dataTypeName: { sequence_id },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Set ID - AIL',
			description: null,
		},
		{
			id: 'AIL.2',
			type: 'Field',
			position: 'AIL.2',
			length: 3,
			dataType: 'ID',
			dataTypeName: { coded_values_for_hl7_tables },
			usage: 'C',
			rpt: '1',
			tableId: '0206',
			tableName: 'Segment action code',
			name: 'Segment Action Code',
			description: null,
		},
		{
			id: 'AIL.3',
			type: 'Field',
			position: 'AIL.3',
			length: 80,
			dataType: 'PL',
			dataTypeName: 'Person Location',
			usage: 'C',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Location Resource ID',
			description: null,
		},
		{
			id: 'AIL.4',
			type: 'Field',
			position: 'AIL.4',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: '0305',
			tableName: 'Person location type',
			name: 'Location Type-AIL',
			description: null,
		},
		{
			id: 'AIL.5',
			type: 'Field',
			position: 'AIL.5',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Location Group',
			description: null,
		},
		{
			id: 'AIL.6',
			type: 'Field',
			position: 'AIL.6',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time',
			description: null,
		},
		{
			id: 'AIL.7',
			type: 'Field',
			position: 'AIL.7',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset',
			description: null,
		},
		{
			id: 'AIL.8',
			type: 'Field',
			position: 'AIL.8',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset Units',
			description: null,
		},
		{
			id: 'AIL.9',
			type: 'Field',
			position: 'AIL.9',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration',
			description: null,
		},
		{
			id: 'AIL.10',
			type: 'Field',
			position: 'AIL.10',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration Units',
			description: null,
		},
		{
			id: 'AIL.11',
			type: 'Field',
			position: 'AIL.11',
			length: 10,
			dataType: 'IS',
			dataTypeName: 'Coded value for user-defined tables',
			usage: 'C',
			rpt: '1',
			tableId: '0279',
			tableName: 'Allow Substitution Codes',
			name: 'Allow Substitution Code',
			description: null,
		},
		{
			id: 'AIL.12',
			type: 'Field',
			position: 'AIL.12',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: '0278',
			tableName: 'Filler status codes',
			name: 'Filler Status Code',
			description: null,
		},
	],
	AIP: [
		{
			id: 'AIP.1',
			type: 'Field',
			position: 'AIP.1',
			length: 4,
			dataType: 'SI',
			dataTypeName: { sequence_id },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Set ID - AIP',
			description: null,
		},
		{
			id: 'AIP.2',
			type: 'Field',
			position: 'AIP.2',
			length: 3,
			dataType: 'ID',
			dataTypeName: { coded_values_for_hl7_tables },
			usage: 'C',
			rpt: '1',
			tableId: '0206',
			tableName: 'Segment action code',
			name: 'Segment Action Code',
			description: null,
		},
		{
			id: 'AIP.3',
			type: 'Field',
			position: 'AIP.3',
			length: 250,
			dataType: 'XCN',
			dataTypeName: { extended_composite_id_number_and_name_for_persons },
			usage: 'C',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Personnel Resource ID',
			description: null,
		},
		{
			id: 'AIP.4',
			type: 'Field',
			position: 'AIP.4',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: '0182',
			tableName: 'Staff type',
			name: 'Resource Type',
			description: null,
		},
		{
			id: 'AIP.5',
			type: 'Field',
			position: 'AIP.5',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Resource Group',
			description: null,
		},
		{
			id: 'AIP.6',
			type: 'Field',
			position: 'AIP.6',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time',
			description: null,
		},
		{
			id: 'AIP.7',
			type: 'Field',
			position: 'AIP.7',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset',
			description: null,
		},
		{
			id: 'AIP.8',
			type: 'Field',
			position: 'AIP.8',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset Units',
			description: null,
		},
		{
			id: 'AIP.9',
			type: 'Field',
			position: 'AIP.9',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration',
			description: null,
		},
		{
			id: 'AIP.10',
			type: 'Field',
			position: 'AIP.10',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration Units',
			description: null,
		},
		{
			id: 'AIP.11',
			type: 'Field',
			position: 'AIP.11',
			length: 10,
			dataType: 'IS',
			dataTypeName: 'Coded value for user-defined tables',
			usage: 'C',
			rpt: '1',
			tableId: '0279',
			tableName: 'Allow Substitution Codes',
			name: 'Allow Substitution Code',
			description: null,
		},
		{
			id: 'AIP.12',
			type: 'Field',
			position: 'AIP.12',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: '0278',
			tableName: 'Filler status codes',
			name: 'Filler Status Code',
			description: null,
		},
	],
	AIS: [
		{
			id: 'AIS.1',
			type: 'Field',
			position: 'AIS.1',
			length: 4,
			dataType: 'SI',
			dataTypeName: { sequence_id },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Set ID - AIS',
			description: null,
		},
		{
			id: 'AIS.2',
			type: 'Field',
			position: 'AIS.2',
			length: 3,
			dataType: 'ID',
			dataTypeName: { coded_values_for_hl7_tables },
			usage: 'C',
			rpt: '1',
			tableId: '0206',
			tableName: 'Segment action code',
			name: 'Segment Action Code',
			description: null,
		},
		{
			id: 'AIS.3',
			type: 'Field',
			position: 'AIS.3',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Universal Service Identifier',
			description: null,
		},
		{
			id: 'AIS.4',
			type: 'Field',
			position: 'AIS.4',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time',
			description: null,
		},
		{
			id: 'AIS.5',
			type: 'Field',
			position: 'AIS.5',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset',
			description: null,
		},
		{
			id: 'AIS.6',
			type: 'Field',
			position: 'AIS.6',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Start Date/Time Offset Units',
			description: null,
		},
		{
			id: 'AIS.7',
			type: 'Field',
			position: 'AIS.7',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration',
			description: null,
		},
		{
			id: 'AIS.8',
			type: 'Field',
			position: 'AIS.8',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Duration Units',
			description: null,
		},
		{
			id: 'AIS.9',
			type: 'Field',
			position: 'AIS.9',
			length: 10,
			dataType: 'IS',
			dataTypeName: 'Coded value for user-defined tables',
			usage: 'C',
			rpt: '1',
			tableId: '0279',
			tableName: 'Allow Substitution Codes',
			name: 'Allow Substitution Code',
			description: null,
		},
		{
			id: 'AIS.10',
			type: 'Field',
			position: 'AIS.10',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'C',
			rpt: '1',
			tableId: '0278',
			tableName: 'Filler status codes',
			name: 'Filler Status Code',
			description: null,
		},
		{
			id: 'AIS.11',
			type: 'Field',
			position: 'AIS.11',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '*',
			tableId: '0411',
			tableName: 'Supplemental Service Information Values',
			name: 'Placer Supplemental Service Information',
			description: null,
		},
		{
			id: 'AIS.12',
			type: 'Field',
			position: 'AIS.12',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '*',
			tableId: '0411',
			tableName: 'Supplemental Service Information Values',
			name: 'Filler Supplemental Service Information',
			description: null,
		},
	],
	AL1: [
		{
			id: 'AL1.1',
			type: 'Field',
			position: 'AL1.1',
			length: 4,
			dataType: 'SI',
			dataTypeName: { sequence_id },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Set ID - AL1',
			description: null,
		},
		{
			id: 'AL1.2',
			type: 'Field',
			position: 'AL1.2',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: '0127',
			tableName: 'Allergen Type',
			name: 'Allergen Type Code',
			description: null,
		},
		{
			id: 'AL1.3',
			type: 'Field',
			position: 'AL1.3',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Allergen Code/Mnemonic/Description',
			description: null,
		},
		{
			id: 'AL1.4',
			type: 'Field',
			position: 'AL1.4',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: '0128',
			tableName: 'Allergy Severity',
			name: 'Allergy Severity Code',
			description: null,
		},
		{
			id: 'AL1.5',
			type: 'Field',
			position: 'AL1.5',
			length: 15,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Allergy Reaction Code',
			description: null,
		},
		{
			id: 'AL1.6',
			type: 'Field',
			position: 'AL1.6',
			length: 8,
			dataType: 'DT',
			dataTypeName: 'Date',
			usage: 'B',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Identification Date',
			description: null,
		},
	],
	APR: [
		{
			id: 'APR.1',
			type: 'Field',
			position: 'APR.1',
			length: 80,
			dataType: 'SCV',
			dataTypeName: 'Scheduling Class Value Pair',
			usage: 'O',
			rpt: '*',
			tableId: '0294',
			tableName: 'Time selection criteria parameter class codes',
			name: 'Time Selection Criteria',
			description: null,
		},
		{
			id: 'APR.2',
			type: 'Field',
			position: 'APR.2',
			length: 80,
			dataType: 'SCV',
			dataTypeName: 'Scheduling Class Value Pair',
			usage: 'O',
			rpt: '*',
			tableId: '0294',
			tableName: 'Time selection criteria parameter class codes',
			name: 'Resource Selection Criteria',
			description: null,
		},
		{
			id: 'APR.3',
			type: 'Field',
			position: 'APR.3',
			length: 80,
			dataType: 'SCV',
			dataTypeName: 'Scheduling Class Value Pair',
			usage: 'O',
			rpt: '*',
			tableId: '0294',
			tableName: 'Time selection criteria parameter class codes',
			name: 'Location Selection Criteria',
			description: null,
		},
		{
			id: 'APR.4',
			type: 'Field',
			position: 'APR.4',
			length: 5,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Slot Spacing Criteria',
			description: null,
		},
		{
			id: 'APR.5',
			type: 'Field',
			position: 'APR.5',
			length: 80,
			dataType: 'SCV',
			dataTypeName: 'Scheduling Class Value Pair',
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Filler Override Criteria',
			description: null,
		},
	],
	ARQ: [
		{
			id: 'ARQ.1',
			type: 'Field',
			position: 'ARQ.1',
			length: 75,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'R',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Placer Appointment ID',
			description: null,
		},
		{
			id: 'ARQ.2',
			type: 'Field',
			position: 'ARQ.2',
			length: 75,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Filler Appointment ID',
			description: null,
		},
		{
			id: 'ARQ.3',
			type: 'Field',
			position: 'ARQ.3',
			length: 5,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Occurrence Number',
			description: null,
		},
		{
			id: 'ARQ.4',
			type: 'Field',
			position: 'ARQ.4',
			length: 22,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Placer Group Number',
			description: null,
		},
		{
			id: 'ARQ.5',
			type: 'Field',
			position: 'ARQ.5',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Schedule ID',
			description: null,
		},
		{
			id: 'ARQ.6',
			type: 'Field',
			position: 'ARQ.6',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Request Event Reason',
			description: null,
		},
		{
			id: 'ARQ.7',
			type: 'Field',
			position: 'ARQ.7',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: '0276',
			tableName: 'Appointment reason codes',
			name: 'Appointment Reason',
			description: null,
		},
		{
			id: 'ARQ.8',
			type: 'Field',
			position: 'ARQ.8',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: '0277',
			tableName: 'Appointment Type Codes',
			name: 'Appointment Type',
			description: null,
		},
		{
			id: 'ARQ.9',
			type: 'Field',
			position: 'ARQ.9',
			length: 20,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Appointment Duration',
			description: null,
		},
		{
			id: 'ARQ.10',
			type: 'Field',
			position: 'ARQ.10',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Appointment Duration Units',
			description: null,
		},
		{
			id: 'ARQ.11',
			type: 'Field',
			position: 'ARQ.11',
			length: 53,
			dataType: 'DR',
			dataTypeName: 'Date/Time Range',
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Requested Start Date/Time Range',
			description: null,
		},
		{
			id: 'ARQ.12',
			type: 'Field',
			position: 'ARQ.12',
			length: 5,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Priority-ARQ',
			description: null,
		},
		{
			id: 'ARQ.13',
			type: 'Field',
			position: 'ARQ.13',
			length: 100,
			dataType: 'RI',
			dataTypeName: 'Repeat Interval',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Repeating Interval',
			description: null,
		},
		{
			id: 'ARQ.14',
			type: 'Field',
			position: 'ARQ.14',
			length: 5,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Repeating Interval Duration',
			description: null,
		},
		{
			id: 'ARQ.15',
			type: 'Field',
			position: 'ARQ.15',
			length: 250,
			dataType: 'XCN',
			dataTypeName: { extended_composite_id_number_and_name_for_persons },
			usage: 'R',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Placer Contact Person',
			description: null,
		},
		{
			id: 'ARQ.16',
			type: 'Field',
			position: 'ARQ.16',
			length: 250,
			dataType: 'XTN',
			dataTypeName: 'Extended Telecommunication Number',
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Placer Contact Phone Number',
			description: null,
		},
		{
			id: 'ARQ.17',
			type: 'Field',
			position: 'ARQ.17',
			length: 250,
			dataType: 'XAD',
			dataTypeName: { extended_address },
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Placer Contact Address',
			description: null,
		},
		{
			id: 'ARQ.18',
			type: 'Field',
			position: 'ARQ.18',
			length: 80,
			dataType: 'PL',
			dataTypeName: 'Person Location',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Placer Contact Location',
			description: null,
		},
		{
			id: 'ARQ.19',
			type: 'Field',
			position: 'ARQ.19',
			length: 250,
			dataType: 'XCN',
			dataTypeName: { extended_composite_id_number_and_name_for_persons },
			usage: 'R',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Entered By Person',
			description: null,
		},
		{
			id: 'ARQ.20',
			type: 'Field',
			position: 'ARQ.20',
			length: 250,
			dataType: 'XTN',
			dataTypeName: 'Extended Telecommunication Number',
			usage: 'O',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Entered By Phone Number',
			description: null,
		},
		{
			id: 'ARQ.21',
			type: 'Field',
			position: 'ARQ.21',
			length: 80,
			dataType: 'PL',
			dataTypeName: 'Person Location',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Entered By Location',
			description: null,
		},
		{
			id: 'ARQ.22',
			type: 'Field',
			position: 'ARQ.22',
			length: 75,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Parent Placer Appointment ID',
			description: null,
		},
		{
			id: 'ARQ.23',
			type: 'Field',
			position: 'ARQ.23',
			length: 75,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Parent Filler Appointment ID',
			description: null,
		},
		{
			id: 'ARQ.24',
			type: 'Field',
			position: 'ARQ.24',
			length: 22,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'C',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Placer Order Number',
			description: null,
		},
		{
			id: 'ARQ.25',
			type: 'Field',
			position: 'ARQ.25',
			length: 22,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'C',
			rpt: '*',
			tableId: null,
			tableName: null,
			name: 'Filler Order Number',
			description: null,
		},
	],
	AUT: [
		{
			id: 'AUT.1',
			type: 'Field',
			position: 'AUT.1',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'O',
			rpt: '1',
			tableId: '0072',
			tableName: 'Insurance Plan ID',
			name: 'Authorizing Payor, Plan ID',
			description: null,
		},
		{
			id: 'AUT.2',
			type: 'Field',
			position: 'AUT.2',
			length: 250,
			dataType: 'CE',
			dataTypeName: { coded_element },
			usage: 'R',
			rpt: '1',
			tableId: '0285',
			tableName: 'Insurance company ID codes',
			name: 'Authorizing Payor, Company ID',
			description: null,
		},
		{
			id: 'AUT.3',
			type: 'Field',
			position: 'AUT.3',
			length: 45,
			dataType: 'ST',
			dataTypeName: { string_data },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Authorizing Payor, Company Name',
			description: null,
		},
		{
			id: 'AUT.4',
			type: 'Field',
			position: 'AUT.4',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Authorization Effective Date',
			description: null,
		},
		{
			id: 'AUT.5',
			type: 'Field',
			position: 'AUT.5',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Authorization Expiration Date',
			description: null,
		},
		{
			id: 'AUT.6',
			type: 'Field',
			position: 'AUT.6',
			length: 30,
			dataType: 'EI',
			dataTypeName: 'Entity Identifier',
			usage: 'C',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Authorization Identifier',
			description: null,
		},
		{
			id: 'AUT.7',
			type: 'Field',
			position: 'AUT.7',
			length: 25,
			dataType: 'CP',
			dataTypeName: 'Composite Price',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Reimbursement Limit',
			description: null,
		},
		{
			id: 'AUT.8',
			type: 'Field',
			position: 'AUT.8',
			length: 2,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Requested Number of Treatments',
			description: null,
		},
		{
			id: 'AUT.9',
			type: 'Field',
			position: 'AUT.9',
			length: 2,
			dataType: 'NM',
			dataTypeName: 'Numeric',
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Authorized Number of Treatments',
			description: null,
		},
		{
			id: 'AUT.10',
			type: 'Field',
			position: 'AUT.10',
			length: 26,
			dataType: 'TS',
			dataTypeName: { time_stamp },
			usage: 'O',
			rpt: '1',
			tableId: null,
			tableName: null,
			name: 'Process Date',
			description: null,
		},
	],
};

export const x12Types = [
	'ANSI835_5010_X221',
	'ANSI835_4010_X091',
	'ANSI837_4010_X096',
	'ANSI837_4010_X097',
	'ANSI837_4010_X098',
	'ANSI837_5010_X222',
	'ANSI837_5010_X223',
	'ANSI837_5010_X231',
	'ANSI277_5010_X214',
	'ANSI270_4010_X092',
	'ANSI271_4010_X092',
	'ANSI277_5010_X212',
];

export const DEFAULT_FIREWALL_RULE_NUMBER = 22;
export const DEFAULT_SSH_KEY =
	'ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIDYLMfHkNGJNkcStJlsbh8L3CL6lzk4xNN2Vm8l4Z7+w amit.agrawal@pop-os';

export const REGEX_PATTERNS = {
	URL: /^(https?):\/\/([a-zA-Z0-9.-]+)(?::\d{1,5})?(?:\/[a-zA-Z0-9_.-]*)*(?:\?[a-zA-Z0-9&=_-]*)?(?:#[a-zA-Z0-9_-]*)?$/,
	CERTIFICATE_NAME: /^[a-zA-Z][a-zA-Z0-9-]+$/,
	COMMON_NAME: /^[a-zA-Z_]\w+$/,
};

export const JAR = 'jar';
